export default {
  getHomeworkById: state => id => state.homeworks.find(homework => homework.lesson.id === id),
};
